import { cn as e } from "../../lib/utils.es.js";
import { Button as t, buttonVariants as n } from "./button.es.js";
import * as r from "react";
import { ChevronDownIcon as i, ChevronLeftIcon as a, ChevronRightIcon as o } from "lucide-react";
import { jsx as s } from "react/jsx-runtime";
import { DayPicker as c, getDefaultClassNames as l } from "react-day-picker";
// libs/ui-lib/src/components/ui/calendar.tsx
function u({ className: t, classNames: r, showOutsideDays: u = !0, captionLayout: f = "label", buttonVariant: p = "ghost", formatters: m, components: h, ...g }) {
	let _ = l();
	return /* @__PURE__ */ s(c, {
		showOutsideDays: u,
		className: e("group/calendar bg-background p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent", String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`, String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`, t),
		captionLayout: f,
		formatters: {
			formatMonthDropdown: (e) => e.toLocaleString("default", { month: "short" }),
			...m
		},
		classNames: {
			root: e("w-fit", _.root),
			months: e("relative flex flex-col gap-4 md:flex-row", _.months),
			month: e("flex w-full flex-col gap-4", _.month),
			nav: e("absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1", _.nav),
			button_previous: e(n({ variant: p }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", _.button_previous),
			button_next: e(n({ variant: p }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", _.button_next),
			month_caption: e("flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)", _.month_caption),
			dropdowns: e("flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium", _.dropdowns),
			dropdown_root: e("relative rounded-md border border-input shadow-xs has-focus:border-ring has-focus:ring-[3px] has-focus:ring-ring/50", _.dropdown_root),
			dropdown: e("absolute inset-0 bg-popover opacity-0", _.dropdown),
			caption_label: e("font-medium select-none", f === "label" ? "text-sm" : "flex h-8 items-center gap-1 rounded-md pr-1 pl-2 text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground", _.caption_label),
			month_grid: e("w-full border-collapse", _.month_grid),
			weekdays: e("flex", _.weekdays),
			weekday: e("flex-1 rounded-md text-[0.8rem] font-normal text-muted-foreground select-none", _.weekday),
			week: e("mt-2 flex w-full", _.week),
			week_number_header: e("w-(--cell-size) select-none", _.week_number_header),
			week_number: e("text-[0.8rem] text-muted-foreground select-none", _.week_number),
			day: e("group/day relative aspect-square h-full w-full p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-md", g.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-md" : "[&:first-child[data-selected=true]_button]:rounded-l-md", _.day),
			range_start: e("rounded-l-md bg-accent", _.range_start),
			range_middle: e("rounded-none", _.range_middle),
			range_end: e("rounded-r-md bg-accent", _.range_end),
			today: e("rounded-md bg-accent text-accent-foreground data-[selected=true]:rounded-none", _.today),
			outside: e("text-muted-foreground aria-selected:text-muted-foreground", _.outside),
			disabled: e("text-muted-foreground opacity-50", _.disabled),
			hidden: e("invisible", _.hidden),
			...r
		},
		components: {
			Root: ({ className: t, rootRef: n, ...r }) => /* @__PURE__ */ s("div", {
				"data-slot": "calendar",
				ref: n,
				className: e(t),
				...r
			}),
			Chevron: ({ className: t, orientation: n, ...r }) => s(n === "left" ? a : n === "right" ? o : i, {
				className: e("size-4", t),
				...r
			}),
			DayButton: d,
			WeekNumber: ({ children: e, ...t }) => /* @__PURE__ */ s("td", {
				...t,
				children: /* @__PURE__ */ s("div", {
					className: "flex size-(--cell-size) items-center justify-center text-center",
					children: e
				})
			}),
			...h
		},
		...g
	});
}
function d({ className: n, day: i, modifiers: a, ...o }) {
	let c = l(), u = r.useRef(null);
	return r.useEffect(() => {
		a.focused && u.current?.focus();
	}, [a.focused]), /* @__PURE__ */ s(t, {
		ref: u,
		variant: "ghost",
		size: "icon",
		"data-day": i.date.toLocaleDateString(),
		"data-selected-single": a.selected && !a.range_start && !a.range_end && !a.range_middle,
		"data-range-start": a.range_start,
		"data-range-end": a.range_end,
		"data-range-middle": a.range_middle,
		className: e("flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-end=true]:hover:bg-primary data-[range-end=true]:hover:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-start=true]:hover:bg-primary data-[range-start=true]:hover:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[selected-single=true]:hover:bg-primary data-[selected-single=true]:hover:text-primary-foreground dark:hover:text-accent-foreground [&>span]:text-xs [&>span]:opacity-70", c.day, n),
		...o
	});
}
export { u as Calendar, d as CalendarDayButton };
